/**
 * Created by ronmarsiano on 12/09/2017.
 */

mainApp.directive('licenseService', function() {
    return {
        restrict: 'A',
        replace: true,
        templateUrl: '/public/directives/licenseService.html',
        scope: {
            service : '=',
            datePickerOptions: "<?"
        },
        controller:  ['$scope', '$state', '$element',"LocationService","$filter","DateTimeService", function($scope,$state, $element,LocationService,$filter,DateTimeService) {
            $scope.statusOptions = ['Trial','Commercial'];

            $scope.active = $scope.service.isEnabled();
            $scope.lifecycle = $scope.service.getLifeCycle();

            $scope.$watch('service.isEnabled()', function(newValue, oldValue) {
                if (newValue == oldValue)
                    return;

                $scope.active = $scope.service.isEnabled();
            }, true);

            $scope.$watch('active', function(newValue, oldValue) {
                if (newValue == oldValue)
                    return;

                $scope.service.setEnabled(newValue);
            }, true);

            $scope.$watch('lifecycle', function(newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    if (newValue == 'Commercial') {
                        $scope.service.setExpiration(0);
                    }
                    else {
                        $scope.service.setExpiration((new Date()).getTime());
                    }
                    $scope.service.setLifeCycle(newValue);
                }
            }, true);
        }]
    };
});


